import {
  ArrowLeft,
  ArrowRight,
  Container,
  Header,
  NoQuestions,
  Pagination,
  Select,
} from './styles';
import { formatBrMoney, formatBrDecimal } from '../../shared/utils';
import { api } from '../../services/api';
import { useGlobalLoading } from '../../contexts/GlobalLoadingContext';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppError } from '../../error/AppError';
import { OptionSelect } from '../../interfaces';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SiMicrosoftexcel } from 'react-icons/si';
import { toast } from 'react-toastify';
import { downloadFileFromServer } from '../../utils/removeMask';
import ReactLoading from 'react-loading';
import { ButtonPrimary, ButtonDownload } from '../DashboardUsers/styles';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

type MarketListProps = {
  id: string | null;
  name: string | null;
  type: string | null;
  label: string | null;
  value: string | null;
};
export default function MarketResult() {
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [markets, setMarkets] = useState<MarketListProps[]>([]);
  const { handleSetIsLoading } = useGlobalLoading();
  const { id } = useParams();
  const [idFilter, setIdFilter] = useState<string>('');
  const [selectedResultOption, setSelectedResultOption] =
    useState<OptionSelect>();
  const [resultsData, setResultsData] = useState([]);
  const [hasExcel, setHasExcel] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPagePositions, setLastPagePositions] = useState(1);
  const [hasData, setHasData] = useState<boolean>(false);

  async function listMarkets() {
    try {
      handleSetIsLoading(true);

      const { data } = await api.get('/markets/statistics/titles?status=published');
      const marketsList = data.map((intermediari) => ({
        label: intermediari.name,
        value: intermediari.id,
      }));
      setMarkets(marketsList);
      handleSetIsLoading(false);
      if (id) {
        setIdFilter(id);
        setSelectedResultOption({ label: id, value: id });
      }
    } catch (error) {
      AppError(error, `Problemas ao carregar a lista!`);
    }
  }

  async function listResultsData(currentPage) {
    try {
      setHasData(false);
      if (selectedResultOption) {
        setHasMore(true);
        const limit = 20;
        const { data } = await api.get(
          `/markets/statistics/items/published?market_statistic_id=${selectedResultOption.value}&page=${currentPage}&limit=${limit}`,
        );
        const marketsList = data.data;

        if (resultsData.length < data.last_page) {
          const marketsFull = resultsData.concat(marketsList);
          setResultsData(marketsFull);
          setLastPagePositions(data.last_page);
          setIdFilter(selectedResultOption.value);
        } else {
          setHasMore(false);
        }
      }
      setHasData(false);
      handleSetIsLoading(false);
    } catch (error) {
      setHasData(false);
      AppError(error, `Problemas ao carregar mercado!`);
    }
  }

  function validValue(type, value) {
    if (value) {
      if (
        type === 'ILP' ||
        type === 'ilp' ||
        type === 'icp' ||
        type === 'ICP' ||
        type === 'media'
      ) {
        return formatBrDecimal(value);
      } else {
        return formatBrMoney(value);
      }
    } else {
      return '';
    }
  }

  function fetchDataMarket() {
    setCurrentPage((value) => value + 1);
  }

  async function handleDownload(market_statistic_id: string) {
    try {
      setHasExcel(true);
      const dataProcess = await api.get(
        `/markets/statistics/items/published/download?market_statistic_id=${market_statistic_id}`,
        { responseType: 'blob' },
      );
      const fileName = dataProcess.headers['content-disposition'].split('=')[1];
      downloadFileFromServer({
        contentType: dataProcess.headers['content-type'],
        data: dataProcess.data,
        filename: fileName,
      });

      toast.success('Download resultado mercado realizado com sucesso!');
      setHasExcel(false);
    } catch (err) {
      toast.error('Erro ao realizar o download resultado mercado !');
      setHasExcel(false);
    }
  }

  useEffect(() => {
    listResultsData(currentPage);
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    setResultsData([]);
    setHasMore(false);
    handleSetIsLoading(true);
    listResultsData(currentPage);
  }, [selectedResultOption]);

  useEffect(() => {
    listMarkets();
  }, []);
  return (
    <Container>
      <Header>
        <h2 className="text-2xl font-bold">Mercados publicados</h2>
      </Header>
      <>
        <div className="grid grid-cols-6 gap-4">
          <div className="col-start-1 col-end-3 ...">
            <Select
              onChange={(option) =>
                setSelectedResultOption(option as OptionSelect)
              }
              options={markets}
              isSearchable={false}
              maxMenuHeight={550}
              value={markets.filter(({ value }) => value === idFilter)}
              placeholder="Escolha um mercado"
            />
          </div>
          <div className="col-end-8 col-span-2 flex justify-end">
            {resultsData && resultsData.length > 0 ? (
              <ButtonDownload
                onClick={() => handleDownload(idFilter)}
                className="mb-5"
                disabled={!hasExcel ? false : true}
                style={{ marginTop: '8px' }}
              >
                {!hasExcel ? (
                  <>
                    <SiMicrosoftexcel
                      size={'25px'}
                      style={{ marginRight: '10px' }}
                    />
                    Exportar para XLS{' '}
                  </>
                ) : (
                  <>
                    <div style={{ paddingRight: '6px' }}>
                      <ReactLoading
                        type="spin"
                        color={'#F56A00'}
                        height={20}
                        width={20}
                      />
                    </div>
                    Aguarde exportação
                  </>
                )}
              </ButtonDownload>
            ) : null}
          </div>
        </div>
      </>
      <div className="grid grid-cols-1 gap-4 mt-6 h-32">
        <div className="ard bg-base-100 shadow-xl p-4">
          <div className="overflow-x-auto">
            <InfiniteScroll
              dataLength={resultsData.length}
              next={fetchDataMarket}
              hasMore={hasMore}
              height={600}
              loader={
                !resultsData ? (
                  <div className="flex justify-center p-5">Carregando...</div>
                ) : (
                  ''
                )
              }
              endMessage={
                resultsData.length > 0 ? (
                  <div
                    className="alert hadow-lg alert-warning alertSalvar"
                    style={{ marginTop: '20px', marginBottom: '30px' }}
                  >
                    <div>
                      <span>
                        Atenção: Não existem mais valores para carregar!!
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )
              }
            >
              {resultsData.length > 0 ? (
                <div>
                  <div className="div1">
                    {!hasData ? (
                      <table className="table w-full">
                        <thead>
                          <tr>
                            <th style={{ display: 'none' }}></th>
                            <th>
                              <strong>Linha</strong>
                            </th>
                            <th>
                              <strong>Cargo</strong>
                            </th>
                            <th>
                              <strong>Grade</strong>
                            </th>
                            <th>
                              <strong>Nº de empresas</strong>
                            </th>
                            <th>
                              <strong>Nº de ocupantes</strong>
                            </th>
                            <th>
                              <strong>P10</strong>
                            </th>
                            <th>
                              <strong>P25</strong>
                            </th>
                            <th>
                              <strong>P50</strong>
                            </th>
                            <th>
                              <strong>P75</strong>
                            </th>
                            <th>
                              <strong>P90</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultsData
                            ? resultsData.map((i: any, index: number) => (
                              <tr key={index}>
                                <td style={{ display: 'none' }}></td>
                                <td>
                                  <span className="uppercase">
                                    {i.statistic_name}
                                  </span>
                                </td>
                                <td>{i.role}</td>
                                <td>{i.grade}</td>
                                <td>{i.tenants_count}</td>
                                <td>{i.employees_calc_count}</td>
                                <td>{validValue(i.statistic_name, i.p10)}</td>
                                <td>{validValue(i.statistic_name, i.p25)}</td>
                                <td>{validValue(i.statistic_name, i.p50)}</td>
                                <td>{validValue(i.statistic_name, i.p75)}</td>
                                <td>{validValue(i.statistic_name, i.p90)}</td>
                              </tr>
                            ))
                            : null}
                        </tbody>
                      </table>
                    ) : (
                      <>
                        <div style={{ marginLeft: '50%', marginTop: '10%' }}>
                          <ReactLoading
                            type="spin"
                            color={'#F56A00'}
                            height={50}
                            width={50}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <NoQuestions>
                  <br></br>
                  <br></br>
                  {selectedResultOption
                    ? 'Item selecionado não localizado'
                    : 'Nenhum item selecionado'}
                </NoQuestions>
              )}
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </Container>
  );
}
